//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import manba from 'manba'
import { mapGetters } from 'vuex'
import { axiosGet, axiosPost } from '../../../../../axios/axios.js'
import { EventBus } from '../../../../../EventBus/EventBus.js'
import { getObjectAdditionalInfo } from '../../../../../forms/Request/RequestGetObjectAdditionalInfo.js'
import { requestActionsAskAdjacentRequests } from '../../../../../forms/Request/RequestActionsAskAdjacentRequests.js'

export default {
  mixins: [getObjectAdditionalInfo, requestActionsAskAdjacentRequests],
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    selectedRequestsIds: {
      type: Array,
      default () {
        return []
      }
    },
    singleRequest: {
      type: Object,
      default () {
        return null
      }
    },
    selectMode: {
      type: Boolean,
      default: false
    },
    updateOnOpen: {
      type: Boolean,
      default: true
    },
    reinforcement: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      initialized: false,
      workDate: null,
      selectedWorkShift: null,
      brigades: [],
      selectedBrigade: null,
      selectedBrigades: [],
      loading: false,
      approveLoading: false,
      openedApproveWindow: false,
      requestsIds: [],
      mode: null,
      confirmAssignmentWithActiveBrigade: false,
      serviceObjectWithActiveBrigadeMessages: []
    }
  },
  computed: {
    ...mapGetters({
      getWorkShifts: 'getWorkShifts'
    }),
    workShifts: function () {
      return this.getWorkShifts.filter(ws => ws.active)
    },
    showExecutorsAvailable: function () {
      return (this.workDate !== null) &&
             (this.selectedWorkShift !== null)
    },
    getNoteText: function () {
      if (this.mode === 'rewriteRequests') {
        return 'Текущие назначенные заявки бригады на выбранную смену удалятся, а вместо них добавятся новые.'
      } else if (this.mode === 'addRequests') {
        return 'В очередь заданий бригады на выбранную смену добавятся выбранные заявки.'
      } else {
        return ''
      }
    }
  },
  watch: {
    opened: {
      handler: function (result) {
        if (this.updateOnOpen || !this.initialized) {
          if (result) {
            this.setDefaultParameters()
            if (!this.initialized) {
              this.loadBrigades()
            }
          } else {
            this.resetParameters()
          }
        }
      },
      immediate: true
    },
    showExecutorsAvailable: function (result) {
      if (this.initialized) {
        if (result) {
          this.loadBrigades()
        } else {
          this.brigades = []
          this.selectedBrigade = null
          this.selectedBrigades = []
        }
      }
    },
    selectedWorkShift: function () {
      if (this.initialized) {
        if (this.workDate && this.selectedWorkShift) {
          this.loadBrigades()
        } else {
          this.brigades = []
          this.selectedBrigade = null
          this.selectedBrigades = []
        }
      }
    },
    workDate: function () {
      if (this.initialized) {
        if (this.workDate && this.selectedWorkShift) {
          this.loadBrigades()
        } else {
          this.brigades = []
          this.selectedBrigade = null
        }
      }
    }
  },
  methods: {
    setDefaultParameters: function () {
      const now = new Date()

      const user = this.$store.getters.getUser
      let limitHoursToDisplayNightWorkShift = 0
      if (user.employee && user.employee.workAreas.includes('СО')) {
        limitHoursToDisplayNightWorkShift = 7
      }

      if (now.getHours() < limitHoursToDisplayNightWorkShift) {
        this.workDate = manba(new Date().setDate(new Date().getDate() - 1)).format('DD-MM-YYYY')
        this.selectedWorkShift = 'brigadier.20-32'
      } else {
        this.workDate = manba(now).format('DD-MM-YYYY')

        if (now.getHours() < 8) {
          this.selectedWorkShift = 'brigadier.7-19'
        } else if (now.getHours() < 20) {
          this.selectedWorkShift = 'brigadier.8-20'
        } else {
          this.selectedWorkShift = 'brigadier.20-32'
        }
      }
    },
    getStartWorkShiftTime: function () {
      const startDate = this.parseDate(this.workDate)
      const workShiftStartHour = this.workShifts.find(workShift => workShift.key === this.selectedWorkShift).startHour
      startDate.setHours(workShiftStartHour)
      return startDate.getTime()
    },
    onSelectBrigadeExact: function (brigade) {
      if (!this.reinforcement) {
        return this.onBrigadeClick(brigade)
      }

      if (brigade) {
        this.selectedBrigades = []
        this.selectedBrigades.push(brigade)
      }
    },
    onSelectBrigadeCtrl: function (brigade) {
      if (!this.reinforcement) {
        return this.onBrigadeClick(brigade)
      }

      if (brigade && this.isSelectedBrigade(brigade)) {
        const index = this.selectedBrigades.indexOf(b => b.id === brigade.id)
        this.selectedBrigades.splice(index, 1, brigade)
      } else {
        this.selectedBrigades.push(brigade)
      }
    },
    onBrigadeClick: function (brigade) {
      this.selectedBrigade = brigade
    },
    onSaveBrigadeRequests: function (mode) {
      this.resultQueue = []

      if (this.selectedBrigade === null) {
        return
      }

      this.resultQueue = this.selectedRequestsIds

      this.mode = mode
      this.openedApproveWindow = true
    },
    onSelectBrigade: function () {
      if (this.selectedBrigade === null) {
        return
      }

      this.$emit('select', this.selectedBrigade)

      this.confirmAssignmentWithActiveBrigade = false
      this.openedApproveWindow = false
    },
    checkActiveBrigadeOnServiceObject: async function () {
      this.serviceObjectWithActiveBrigadeMessages = []
      const requestsIds = this.resultQueue

      for (let i = 0; i < requestsIds.length; i++) {
        // TODO: надо передать объект
        const continueAssignmentText = await this.checkObjectHasActiveBrigade(requestsIds[i], this.selectedBrigade.id)
        if (continueAssignmentText !== '') {
          this.serviceObjectWithActiveBrigadeMessages.push(continueAssignmentText)
        }
      }

      if (this.serviceObjectWithActiveBrigadeMessages.length !== 0) { // Требуется подтверждение.
        this.confirmAssignmentWithActiveBrigade = true
      } else {
        this.saveBrigadeQueue()
      }
    },
    saveBrigadeQueue: async function () {
      this.approveLoading = true
      let continueSave = true
      let hasAdjacentObjectsRequests = false
      for (const requestId of this.resultQueue) {
        const adjacentObjectsRequestsTextArray = await this.getAdjacentObjectsRequests(requestId)
        hasAdjacentObjectsRequests |= adjacentObjectsRequestsTextArray && adjacentObjectsRequestsTextArray.length
      }
      if (hasAdjacentObjectsRequests) {
        continueSave = await this.askAdjacentRequests('Назначить исполнителя', this.resultQueue, null, null)
      }
      if (!continueSave) {
        this.approveLoading = false
        return
      }

      const requestsIds = this.resultQueue
      const bodyFormData = new FormData()

      bodyFormData.set('id', this.selectedBrigade.id)
      bodyFormData.set('ignoreEndWorkTime', true)
      bodyFormData.set('workDate', this.parseDate(this.workDate).getTime())
      bodyFormData.set('workShift', this.selectedWorkShift)
      if (requestsIds) {
        bodyFormData.set('requests', requestsIds.join(','))
      }
      if (this.mode === 'addRequests') {
        bodyFormData.set('append', true)
      }

      axiosPost({
        url: '/service/delta/brigade/saveQueue',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешное изменение очереди заданий бригады',
            progress: true,
            timeout: 3000
          })

          EventBus.$emit('update-request', { savePage: true, saveScroll: true })
          EventBus.$emit('update-requestsQueue', {})
          EventBus.$emit('update-request-popup', {})

          this.confirmAssignmentWithActiveBrigade = false
          this.openedApproveWindow = false
          this.onSuccess()
        },
        onFailure: 'Ошибка изменения очереди заданий бригады',
        msgTarget: this
      }).finally(() => {
        this.approveLoading = false
      })
    },
    onSelectBrigadesReinforcement: function (ignoreErrors = false) {
      this.approveLoading = true

      const bodyFormData = new FormData()

      bodyFormData.set('brigades', this.selectedBrigades.map(b => b.id).join())
      bodyFormData.set('ignoreErrors', false)
      bodyFormData.set('workDate', this.parseDate(this.workDate).getTime())
      bodyFormData.set('workShift', this.selectedWorkShift)
      if (this.selectedRequestsIds) {
        bodyFormData.set('requests', this.selectedRequestsIds.join(','))
      }

      axiosPost({
        url: '/service/delta/brigade/assignReinforcements',
        data: bodyFormData,
        onSuccess: (response) => {
          if (response.data.badRequests && response.data.badRequests.length) {
            if (response.data.badRequests.length < this.selectedRequestsIds.length) {
              const successRequestLength = this.selectedRequestsIds.length - response.data.badRequests.length
              this.$q.notify({
                type: 'positive',
                message: `Успешное добавление бригад на усиление на ${successRequestLength}/${this.selectedRequestsIds.length}  заявок`,
                progress: true,
                timeout: 4000
              })
            }
            this.$q.notify({
              type: 'negative',
              message: response.data.badRequests.map(r => r.message).join('\n'),
              progress: true,
              timeout: 8000
            })
          } else {
            this.$q.notify({
              type: 'positive',
              message: 'Успешное добавление бригад на усиление',
              progress: true,
              timeout: 3000
            })
          }

          EventBus.$emit('update-request', { savePage: true, saveScroll: true })
          EventBus.$emit('update-requestsQueue', {})
          EventBus.$emit('update-request-popup', {})

          this.onSuccess()
        },
        onFailure: 'Ошибка добавления бригад на усиление'
      }).finally(() => {
        this.approveLoading = false
      })
    },
    onSuccess: function () {
      this.$emit('success')
    },
    onClose: function () {
      this.$emit('close')
    },
    formatDateToTimestamp (value) {
      const match = value.match(/^(\d+)-(\d+)-(\d+)$/)
      const timestamp = new Date(match[3], match[2] - 1, match[1])
      return timestamp.getTime()
    },
    resetParameters: function () {
      this.workDate = null
      this.selectedWorkShift = null
    },
    loadBrigades: async function () {
      this.loading = true

      try {
        const brigades = await this.getBrigades(this.selectedWorkShift, this.workDate, this.singleRequest)

        if (!this.initialized && this.selectedWorkShift === 'brigadier.8-20' && brigades.length === 0) {
          this.selectedWorkShift = 'brigadier.7-19'
          this.brigades = await this.getBrigades(this.selectedWorkShift, this.workDate, this.singleRequest)
        } else {
          this.brigades = brigades
        }
      } catch (e) {
        this.brigades = []
      } finally {
        this.loading = false

        if (!this.initialized) {
          this.$nextTick(() => {
            this.initialized = true
          })
        }
      }
    },
    getBrigades: function (workShift, workDate = this.workDate, request) {
      const params = new URLSearchParams()
      params.set('state', 'valid')

      const fields = ['guiName', 'workShift', 'workAreas', 'startWorkTime']
      if (workShift != null) {
        const workDateMillis = this.formatDateToTimestamp(workDate)
        params.set('workDate', workDateMillis)
        params.set('workShift', workShift)
      } else {
        // Для select в popup заявки
        const nowMillis = new Date().getTime()
        const workDateMillis = this.formatDateToTimestamp(manba(new Date()).format('DD-MM-YYYY'))
        const endTime = Math.max(nowMillis + 12 * 3600000, workDateMillis + 24 * 3600000)
        params.set('starttime', nowMillis)
        params.set('endtime', endTime)
        params.set('onlyActiveOrFuture', true)
        fields.push('contractor', 'workShiftsEmployees')
      }

      if (request) {
        if (request.requestId) {
          params.set('requestToAssign', request.requestId)
        }
        fields.push('hasForkliftTruck', 'forkliftTruckProvisionRequests')
      }
      params.set('fields', fields.join(','))

      return axiosGet({
        url: '/service/delta/brigade/lightsearch?' + params.toString(),
        onSuccess: (response) => {
          const brigades = []
          response.data.forEach(brigade => {
            const workShiftsData = brigade.workShiftsEmployees
            if (!workShiftsData || !workShiftsData.length || brigade.contractor) {
              brigades.push(brigade)
            } else {
              workShiftsData.forEach(workShiftData => {
                const brigadeOnWorkShift = Object.assign({}, brigade, {
                  workShiftsEmployees: null,
                  workShift: workShiftData.workShift,
                  startWorkTime: workShiftData.startTime,
                  endWorkTime: workShiftData.endTime,
                  guiName: brigade.name + '(' + workShiftData.employees.sort((e1, e2) => ((e1.brigadier === e2.brigadier) ? 0 : e1.brigadier ? -1 : 1)).map(employee => employee.fio).join(', ') + ')'
                })
                brigades.push(brigadeOnWorkShift)
              })
            }
          })
          brigades.forEach(brigade => {
            brigade.brigadeId = brigade.id
            brigade.brigadeName = brigade.name

            if (brigade.startWorkTime) {
              brigade.workDateMillis = this.formatDateToTimestamp(manba(new Date(brigade.startWorkTime)).format('DD-MM-YYYY'))
            }

            brigade.warnings = []
            if (brigade.forkliftTruckMatchInfo) {
              brigade.forkliftTruckMessage = brigade.forkliftTruckMatchInfo.message

              const matchState = brigade.forkliftTruckMatchInfo.state
              if (matchState === 'success') {
                brigade.forkliftTruckColor = 'green'
              } else {
                brigade.warnings.push(brigade.forkliftTruckMessage)

                if (matchState == 'warning') {
                  brigade.forkliftTruckColor = 'orange'
                } else {
                  brigade.forkliftTruckColor = 'red'
                }
              }
            }
          })
          return brigades
        },
        onFailure: 'Ошибка загрузки бригад',
        msgTarget: this
      })
    },
    parseDate (value) {
      const pattern = /(\d{2})-(\d{2})-(\d{4})/
      const date = new Date(value.replace(pattern, '$3-$2-$1'))
      date.setHours(0, 0, 0, 0)
      return date
    },
    isSelectedBrigade: function (brigade) {
      if (this.reinforcement) {
        return !!this.selectedBrigades.find(b => b.brigadeId === brigade.id)
      } else {
        return !!this.selectedBrigade && brigade.id === this.selectedBrigade.id
      }
    },
    getBrigadeBgColor: function (brigade) {
      if (this.isSelectedBrigade(brigade)) {
        return 'blue'
      } else {
        return 'gray'
      }
    }
  }
}

